module.exports = __webpack_public_path__ + "img/Freek_04.8bd30cab.jpg";